import { createReducer } from '@reduxjs/toolkit'

import { resetParticipantContext } from 'containers/Participants/Redux/Actions/FilterBuilder'
import {
  setParticipants,
  setPage,
  setPerPage,
  setSort,
  searchByNameOrEmail,
  updateParticipant,
  updateSelection,
  setGridLoaderStatus,
} from 'containers/Participants/Redux/Actions/ParticipantGrid'
import { initialState } from 'containers/Participants/Redux/Reducer/InitialState'
import { Participant } from 'types/Participants'
import { setSelectAll } from 'containers/Participants/Redux/Actions/SelectAll'
// linting ignored as yarn format is causing unwanted semicolons to appear.
// prettier-ignore
export const participantsReducer = createReducer(initialState, {
  [searchByNameOrEmail.type]: (state, action) => {
      state.filterQuery.search = action.payload,
      state.queries.per_page = 25,
      state.queries.page = 1,
      state.sortModel = initialState.sortModel,
      state.filterQuery.sort = initialState.filterQuery.sort,
      state.loading = true
  },

  [setParticipants.type]: (state, action) => {
      state.participants = action.payload.participants,
      state.meta = action.payload.meta,
      state.loading = false
  },

  [setPerPage.type]: (state, action) => {
      state.queries.per_page = action.payload,
      state.queries.page = 1,
      state.loading = true
  },

  [setPage.type]: (state, action) => {
      state.queries.page = action.payload, state.loading = true
  },

  [setSort.type]: (state, action) => {
      state.filterQuery.sort = action.payload.sort,
      state.sortModel = action.payload.model,
      state.loading = true,
      state.queries.page = 1
  },

  [updateParticipant.type]: (state, action) => {
    const updatingIndex: number = state.participants.findIndex((participant: Participant) => participant.id === action.payload.participant.id)
    const newParticipants: any = [...state.participants]
    newParticipants[updatingIndex] = action.payload.participant
    state.participants = newParticipants
  },

  [resetParticipantContext.type]: (state) => {
    state.queries = initialState.queries,
    state.sortModel = initialState.sortModel,
    state.filterQuery.sort = initialState.filterQuery.sort
    state.filterQuery.search = initialState.filterQuery.search
  },

  [updateSelection.type]: (state, action) => {
    state.selectedParticipantIDs = action.payload.participantIDs
  },

  [setSelectAll.type]: (state, action) => {
    state.selectAll = action.payload.selectAll
  },

  [setGridLoaderStatus.type]: (state, action) => {
    state.loading = action.payload
  }
})

export default participantsReducer
